// Email service for sending real emails via Supabase Edge Functions
import { supabase } from './supabase'

class EmailService {
  constructor() {
    this.baseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://wkscjmjdllqcgwqmwjfe.supabase.co'
  }

  async sendMagicLink(email, token, cityName = null) {
    try {
      console.log('🚀 Sending magic link email to:', email)

      const { data, error } = await supabase.functions.invoke('send-magic-link', {
        body: {
          email: email,
          type: 'magic_link',
          token: token,
          cityName: cityName
        }
      })

      if (error) {
        console.error('❌ Failed to send magic link email:', error)
        throw error
      }

      console.log('✅ Magic link email sent successfully:', data)
      return {
        success: true,
        messageId: data.messageId,
        message: 'Magic link sent successfully'
      }

    } catch (error) {
      console.error('❌ Email service error:', error)
      
      // Fallback to console logging for development
      if (import.meta.env.DEV) {
        console.log(`📧 FALLBACK: Magic link for ${email}`)
        console.log(`🔗 Token: ${token}`)
        console.log(`🔗 URL: ${window.location.origin}/#/?token=${token}`)
        
        return {
          success: true,
          message: 'Magic link logged to console (development mode)',
          fallback: true
        }
      }

      throw error
    }
  }

  async sendVerificationEmail(email, token, cityName = null) {
    try {
      console.log('🚀 Sending verification email to:', email)

      const { data, error } = await supabase.functions.invoke('send-magic-link', {
        body: {
          email: email,
          type: 'verification',
          token: token,
          cityName: cityName
        }
      })

      if (error) {
        console.error('❌ Failed to send verification email:', error)
        throw error
      }

      console.log('✅ Verification email sent successfully:', data)
      return {
        success: true,
        messageId: data.messageId,
        message: 'Verification email sent successfully'
      }

    } catch (error) {
      console.error('❌ Email service error:', error)
      
      // Fallback to console logging for development
      if (import.meta.env.DEV) {
        console.log(`📧 FALLBACK: Verification email for ${email}`)
        console.log(`🔗 Token: ${token}`)
        console.log(`🔗 URL: ${window.location.origin}/#/?token=${token}`)
        
        return {
          success: true,
          message: 'Verification email logged to console (development mode)',
          fallback: true
        }
      }

      throw error
    }
  }

  async sendWelcomeEmail(email, cityName = null) {
    try {
      console.log('🚀 Sending welcome email to:', email)

      const { data, error } = await supabase.functions.invoke('send-magic-link', {
        body: {
          email: email,
          type: 'welcome',
          cityName: cityName
        }
      })

      if (error) {
        console.error('❌ Failed to send welcome email:', error)
        // Don't throw error for welcome emails - they're not critical
        return { success: false, error: error.message }
      }

      console.log('✅ Welcome email sent successfully:', data)
      return {
        success: true,
        messageId: data.messageId,
        message: 'Welcome email sent successfully'
      }

    } catch (error) {
      console.error('❌ Welcome email service error:', error)
      // Don't throw error for welcome emails - they're not critical
      return { success: false, error: error.message }
    }
  }

  // Check if email service is properly configured
  async checkServiceHealth() {
    try {
      // Try to ping the edge function
      const response = await fetch(`${this.baseUrl}/functions/v1/send-magic-link`, {
        method: 'OPTIONS',
        headers: {
          'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
        }
      })

      return {
        available: response.ok,
        status: response.status
      }
    } catch (error) {
      console.warn('Email service health check failed:', error)
      return {
        available: false,
        error: error.message
      }
    }
  }
}

// Create singleton instance
const emailService = new EmailService()

export default emailService